import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function StickyHeader() {
  return <header className="sticky top-0 z-40 w-full bg-blue-900 text-white shadow-md" data-id="element-192">
      <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between" data-id="element-193">
        <div className="flex items-center gap-2 font-bold text-xl tracking-tight" data-id="element-194">
          <span className="text-blue-300" data-id="element-195">Ortho</span>Relief
        </div>
        <div className="flex items-center gap-2 text-sm font-medium bg-blue-800 px-3 py-1 rounded-full" data-id="element-196">
          <ShieldCheckIcon className="w-4 h-4 text-green-400" data-id="element-197" />
          <span className="hidden sm:inline" data-id="element-198">Compra 100% Segura</span>
          <span className="sm:hidden" data-id="element-199">Seguro</span>
        </div>
      </div>
    </header>;
}